import { WalletTransactionType, schemes, zSchema } from "@zeal/common";

export const getWalletTransactionRequestSchema = zSchema.object({
  wallet_transaction_id: schemes.uuid(),
});

export type TGetWalletTransactionRequestSchema = zSchema.infer<
  typeof getWalletTransactionRequestSchema
>;

export const getWalletTransactionResponseSchema = zSchema.object({
  bank_account_id: schemes.mongoOrUuid().nullish(),
  bank_account: zSchema
    .object({
      type: zSchema.string(),
      number: zSchema.string(),
    })
    .optional(),
  card_id: schemes.uuid().nullish(),
  date: zSchema.string(),
  description: zSchema.string(),
  gross_amount: zSchema.number(),
  last_four: zSchema.string().nullish(),
  net_amount: zSchema.number(),
  partner_fee: zSchema.number(),
  type: zSchema.nativeEnum(WalletTransactionType),
  walletTransactionID: schemes.uuid(),
  zeal_fee: zSchema.number(),
});

export type TGetWalletTransactionResponseSchema = zSchema.infer<
  typeof getWalletTransactionResponseSchema
>;
